import React, { useCallback, useContext } from 'react';
import styled from '@emotion/styled';
import Icon from '@leafygreen-ui/icon';
import { palette } from '@leafygreen-ui/palette';
import { theme } from '../../theme/docsTheme';
import { displayNone } from '../../utils/display-none';
import { SidenavContext } from './sidenav-context';

const Container = styled('div')`
  align-items: center;
  background-color: ${palette.gray.light3};
  border-bottom: 1px solid ${palette.gray.light2};
  display: flex;
  height: ${theme.header.docsMobileMenuHeight};
  justify-content: space-between;
  width: 100vw;

  ${displayNone.onLargerThanTablet}
`;

const Text = styled('div')`
  color: ${palette.black};
  margin-left: ${theme.size.large};
`;

const StyledIcon = styled(Icon)`
  margin-right: ${theme.size.medium};
`;

const SidenavMobileMenuDropdown = () => {
  const { hideMobile, setHideMobile } = useContext(SidenavContext);

  const clickDropdown = useCallback(() => {
    setHideMobile((state) => !state);
  }, [setHideMobile]);

  return (
    <Container onClick={clickDropdown}>
      <Text>Docs Menu</Text>
      <StyledIcon glyph={hideMobile ? 'ChevronDown' : 'ChevronUp'} />
    </Container>
  );
};

export default SidenavMobileMenuDropdown;
